import * as firebase from "firebase"

import config from './config'

import shortid from "shortid"

/**
 * Retrieves or generates unique user id on the device
 */
let uid = localStorage.getItem('uid')
if (!uid) {
    uid = shortid.generate()
    localStorage.setItem('uid', uid)
}

firebase.initializeApp(config.firebase);
let database = firebase.database()

export const firebaseBackup = function (data) {
    database.ref('users/'+uid).set(data)
}

export default database


// WEBPACK FOOTER //
// ./src/database.js